import request from '../utils/request'
import setting from './apiSetting'

const TYPE = 'User'

const myfunction = {
  GetSubUsersTrackers: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetSubUsersTrackers'),
      method: 'get',
      params: data,
    })
  },

  GetAnnouncement: function () {
    return request({
      url: setting.getFullUrl(TYPE, 'GetAnnouncement'),
      method: 'get',
    })
  },

  /**
   * 获取所有警类的汇总
   */
  GetAlarmType: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetUserAlarmType'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 获取用户信息
   */
  GetSimpleUser: function (data) {
    const params = {
      ...(data || {}),
      _ts: Date.now(),
    }

    return request({
      url: setting.getFullUrl(TYPE, 'GetSimpleUser'),
      method: 'get',
      params,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
      // 登录后首页初始化依赖此请求：10s 超时后走 management 兜底，避免弱网下页面长期卡在加载
      timeout: 10000,
    })
  },

  /**
   * 获取用户信息
   */
  GetSimpleUserInfo: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetSimpleUserInfo'),
      method: 'get',
      params: data,
    })
  },

  /**
   * 更换用户信息
   */
  UpdateUser: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'UpdateUser'),
      method: 'get',
      params: data,
    })
  },

  /**
   * 更换用户密码
   * 安全整改(2026-08)：改为 POST + FormData，新旧密码不再出现在 URL 查询串上。
   * 查询串会被浏览器历史、代理缓存与 Nginx 访问日志完整记录，HTTPS 也无法避免。
   * 后端 User/UpdateUserPassword 已移除 HttpGet，只接受 POST。
   */
  UpdateUserPass: function (data) {
    const formData = new FormData()
    Object.keys(data || {}).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key])
      }
    })

    return request({
      url: setting.getFullUrl(TYPE, 'UpdateUserPassword'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 修改台年数
   */
  UpdateUserCredit: function (data) {
    // 安全整改(2026-08)：transferPwd 不能出现在 URL 查询串中，改走请求体 form-data
    const formData = new FormData()
    formData.append('sAccount', data.sAccount)
    formData.append('credit', data.credit)
    formData.append('creditDVR', data.creditDVR == null ? 0 : data.creditDVR)
    formData.append('transferPwd', data.transferPwd)
    return request({
      url: setting.getFullUrl(TYPE, 'UpdateUserCredit'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 批量修改设备过期提醒天数
   */
  BatchUpdateTrackerRemindDays: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'BatchUpdateTrackerRemindDays'),
      method: 'post',
      data: data,
    })
  },

  //把所有子用户信息导出到excel
  exportExcel: function (page, params, filename) {
    const timeoutTimer = setTimeout(() => {
      page.loadingInstance.close()
      page.$Tools.showtipMessage(page, page.$t('requestOverTime'), 'error')
    }, 30000)
    page
      .axios({
        url: setting.getFullUrl(TYPE, 'ExcelExport'),
        params: params,
        method: 'post',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('ms_token'),
          'Accept-Language': localStorage.getItem('language'),
        },
        responseType: 'blob',
      })
      .then((res) => {
        clearTimeout(timeoutTimer)
        page.loadingInstance.close()
        if (res.data) {
          if (res.data.size > 0) {
            let suffix = '.xlsx'
            const blob = new Blob([res.data])
            //创建下载链接
            let link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', filename + suffix)
            link.click()
            link = null
          } else {
            page.$message.warning(page.$t('tips.emptyData'))
          }
        } else {
          page.$message.warning(res.data.msg)
        }
      })
      .catch((error) => {
        clearTimeout(timeoutTimer)
        page.loadingInstance.close()
        if (error.response && error.response.status === 400) {
          page.$message.error(error.response.data?.message)
        } else {
          const errorMsg = error.response?.data?.message || 'export error'
          page.$message.error(errorMsg)
        }
      })
  },
}

export default myfunction
